/**
 * Back redirect do checkout (spec 045, 3.10; Vitor, 09/10): pra onde o "voltar" de cada checkout de compra leva (o botao
 * Voltar e o voltar do navegador), ex.: a pagina de uma oferta. Vazio, o site da marca (3.7). O administrador define na
 * criacao e troca depois, quando a campanha muda. So `https://` completo: a regra e a do servico de pagamentos (vem do
 * `@mtc/contratos`), e ele confere de novo. O `/pagar` (mensalidade e cobranca) nao tem back redirect: e sempre o site.
 */
import { Botao, Campo } from "@mtc/ui";
import { useId, useState } from "react";
import { useApi } from "../api";
import { config } from "../config";
import { campoDeVoltarParaOk, erroDoVoltarPara, voltarParaDoCampo } from "../voltarPara";
import { DialogoDeAcao } from "./DialogoDeAcao";

const PAG = (caminho: string) => `${config().PAGAMENTOS_URL.replace(/\/$/, "")}${caminho}`;
const ROTULO = "Back redirect (para onde o cliente vai ao voltar)";

/** O campo do back redirect, com a dica do site da marca e o erro na hora certa (`erroDoVoltarPara`). */
export function CampoVoltarPara({ id, valor, aoMudar }: { id?: string; valor: string; aoMudar: (v: string) => void }) {
  const [saiu, setSaiu] = useState(false);
  const site = config().LANDING_URL;
  return (
    <Campo
      id={id}
      rotulo={ROTULO}
      valor={valor}
      aoMudar={(v) => { setSaiu(false); aoMudar(v); }}
      onBlur={() => setSaiu(true)}
      type="url"
      inputMode="url"
      autoComplete="off"
      spellCheck={false}
      maxLength={500}
      placeholder="https://"
      erro={erroDoVoltarPara(valor, saiu)}
      dica={site ? `Vazio: o site da marca (${site}).` : "Vazio: o site da marca."}
    />
  );
}

type CheckoutComVoltar = { id: string; nome: string; voltar_para: string | null };

/** "Mudar back redirect" de um checkout que ja existe: o endereco atual vem preenchido; limpar volta pro site da marca. */
export function DialogoVoltarPara({ checkout, aoFechar, aoConcluir }: { checkout: CheckoutComVoltar | null; aoFechar: () => void; aoConcluir: (c: CheckoutComVoltar, novo: string | null) => void }) {
  const { por } = useApi();
  const [valor, setValor] = useState("");
  const id = useId();
  const novo = voltarParaDoCampo(valor);
  // Limpar tira o botao da tela: o foco volta pro campo, em vez de cair no fundo da pagina.
  const usarOSite = () => { setValor(""); document.getElementById(id)?.focus(); };
  const mudou = Boolean(checkout) && novo !== (checkout?.voltar_para ?? null);
  return (
    <DialogoDeAcao
      aberto={Boolean(checkout)}
      aoFechar={aoFechar}
      titulo="Mudar back redirect"
      descricao={checkout ? `${checkout.nome}: o botão Voltar e o voltar do navegador levam pra este endereço. Vale na hora pra quem abrir o link.` : undefined}
      botao="Salvar back redirect"
      podeEnviar={mudou && campoDeVoltarParaOk(valor)}
      aoAbrir={() => setValor(checkout?.voltar_para ?? "")}
      aoEnviar={() => por(PAG(`/v1/admin/checkouts/${checkout!.id}/voltar-para`), { voltar_para: novo })}
      aoConcluir={() => { if (checkout) aoConcluir(checkout, novo); }}
    >
      <CampoVoltarPara id={id} valor={valor} aoMudar={setValor} />
      {valor && (
        <div>
          <Botao variante="secundario" tamanho="pequeno" onClick={usarOSite}>Usar o site da marca</Botao>
        </div>
      )}
    </DialogoDeAcao>
  );
}
